const getExportPriceCountryCodes = item => {
  return item?.export_details
    ?.map(exportPrice => exportPrice.country_code)
    .sort()
    .join(',')
}

export const haveAllItemsSameExportPriceCountries = product => {
  const itemsExportPriceCountryCodes = product?.inventory_items?.map(item => getExportPriceCountryCodes(item))

  return new Set(itemsExportPriceCountryCodes).size === 1
}
